import {combineReducers, configureStore} from "@reduxjs/toolkit"
import clientReducer from "./slices/clientSlice"
import authReducer from "./slices/authSlice"
import brigadeReducer from "./slices/brigadeSlice"
import employeeReducer from "./slices/employeeSlice"
import handbookReducer from "./slices/handbookSlice"
import medicalReducer from "./slices/medicalSlice"
import orderReducer from "./slices/orderSlice"
import socketReducer from "./slices/socketSlice"
import callReducer from "./slices/callSlice"
import notificationReducer from "./slices/notificationSlice"
import managerReducer from "./slices/managerSlice"

const rootReducer = combineReducers({
  auth: authReducer,
  handbook: handbookReducer,
  employee: employeeReducer,
  client: clientReducer,
  brigade: brigadeReducer,
  medical: medicalReducer,
  order: orderReducer,
  manager: managerReducer,
  socket: socketReducer,
  call: callReducer,
  notification: notificationReducer
})

export function setupStore() {
  return configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({serializableCheck: false})
  })
}

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
